import { Component, OnInit, Input} from '@angular/core';
import { NotificationService } from '../../../../services/notification.service';

import { ViewService } from '../../../../services/view.service';
import { RecordService } from '../../../../services/record.service';

import { ActivitiesService } from '../../../../services/activities.service';
import { LocalStorageService } from '../../../../services/local-storage.service';
import { blank, data_get, data_is_true, fallback, filled, generate_id, get_text_color_from_hex, observe, when, whenFilled } from '../../../utils/common';
import { distinctUntilChanged, filter } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import { LooseObject } from '../../../../objects/loose-object';
import { ClientStoreService } from '../../../../services/client-store.service';
import { TranslateService } from '@ngx-translate/core';
import { DropdownService } from '../../../../services/dropdown.service';

@Component({
  selector: 'app-statuswidget',
  templateUrl: './statuswidget.component.html',
  styleUrls: ['./statuswidget.component.scss']
})
export class StatuswidgetComponent implements OnInit {
  @Input() objRecordDetails: object;
  public strStatusSelected: any = [];
  public strSubstatusSelected: any = [];
  public strJobTypeSelected: any = [];
  public arStatusList: any = [];
  public arStatusCustomCSS: any = [];
  public numInstanceId = Math.floor(Math.random() * 100000) + 1;
  public strField = 'status';
  public objPointOfNonConvertible = {
    'leads': 4
  };

  bEditable: boolean = true;

  public hoveredSubstatus: any;

  jobStatus: LooseObject = [];
  newSubStatus: LooseObject = [];
  jobSubStatus$ = new BehaviorSubject<LooseObject[]>([]);
  bShowSubstatus: boolean = false;
  jobTypes: LooseObject = [];

  constructor(
    private viewService: ViewService,
    private notifService: NotificationService,
    private recordService: RecordService,
    private readonly _activities:ActivitiesService,
    private localStorageService: LocalStorageService,
    private clientStoreService: ClientStoreService,
    private translateService: TranslateService,
    private dropdownService: DropdownService
    ) {
      // Waiting to pass status list
      this.viewService.arStatusWidget.distinctUntilChanged().subscribe( objData => {

        if (objData) {

          // Set the field name.
          if (objData['field'] != undefined) {
          this.strField = objData['field'];
        }
        // Make sure this is is always empty before creating
        this.arStatusList = [];
        // Do we have option and id key?
        if (objData['id'] && objData['option']) {
          let intPosition = 1;
          // Create status list
          objData['option'].forEach( data => {
            // Do we have these values?
            if (data['id'] && data['text']) {
              const allowedRoles = data_get(data, 'allowed_roles');
              this.arStatusList.push({
                id: data['id'],
                label: data['text'],
                position: intPosition,
                color: data['color'],
                status_id: data['status_id'],
                is_allowed: this.isStatusChangeAllowed(allowedRoles, 'status')
              });
              intPosition++;
            }
          });
          // Do we have list?
          if (this.arStatusList) {
            // Sort status by position
            this.arStatusList.sort((a, b) => {
              if (a.position < b.position) return -1;
              else if (a.position > b.position) return 1;
              else return 0;
            });

            // Find the index.
            let numStatusIndex = this.arStatusList.findIndex(x=>x['id'] == objData['id']);

            // If it's not there, set as the first.
            if (numStatusIndex == -1) {
              this.strStatusSelected = this.arStatusList[0];
            } else {
              // Store selected status
              this.strStatusSelected = this.arStatusList[numStatusIndex];
            }

            if (filled(objData['substatus'])) {
              this.strSubstatusSelected['key'] = objData['substatus'];
            }

            if (filled(objData['job_type'])) {
              this.strJobTypeSelected['key'] = objData['job_type'];
            }

            // Count and divide it to 100 so that every status button has same width
            this.arStatusCustomCSS = {
              'width': (100/this.arStatusList.length).toString()+ '%'
            }
          }
        }
      }

      this.viewService.bStatusWidgetEditable
      .pipe(
        distinctUntilChanged()
      )
      .subscribe( bEditable => {
        console.log('bEditable', bEditable)
        this.bEditable = bEditable
      } );
    });

    // Waiting to pass the new status
    this.viewService.strStatusValue.distinctUntilChanged().subscribe( strValue => {
      if (strValue && typeof (strValue) == 'string') {
        Object.keys(this.arStatusList).forEach( key => {
          if (this.arStatusList[key].id == strValue) {
            this.strStatusSelected = this.arStatusList[key];
          }
        });
      }
    })
  }

  ngOnInit() {
    this.viewService.updateStatusWidget({
      instance_id: this.numInstanceId
    });

    if (this.objRecordDetails['module'] == 'jobs') {
      this.getStatus();
    }
  }

  /**
   * Begin status update process. If update requires confirmation, wait for user to confirm first.
   * Otherwise, proceed directly to status update.
   * @param objStatus
   */
  updateStatus(arStatus) {
    console.log('this.bEditable', this.bEditable)
    // Do we have different status?
    if (this.strStatusSelected['id'] != arStatus['id'] && this.bEditable) {
      if ((this.objPointOfNonConvertible[this.objRecordDetails['module']] < this.strStatusSelected['position'] && arStatus['position'] < this.strStatusSelected['position']) || this.strStatusSelected['id'] == 'converted') {
        this.notifService.sendNotification('not_allowed', 'cannot_convert', 'warning', 5000);
      } else if (this.objRecordDetails['module'] == 'opportunities' && arStatus['id'] == 'closed_lost') {
        // Pass the status widget value, so we can preview the convert dialog.
        this.viewService.updateStatusWidget({
          type: 'reason_for_lost',
          id: this.numInstanceId,
          data: { module: this.objRecordDetails['module'], id: this.objRecordDetails['id'], status: arStatus['id']},
          instance_id: this.numInstanceId
        });
      } else if (this.objRecordDetails['module'] === 'jobs' && arStatus['id'] === 'cancelled') {
        this.notifService.sendConfirmation("confirm_cancel_job", "confirmation", "default")
        .pipe(
          filter(confirmation => confirmation.answer === true),
        )
        .subscribe( () => {
          this.saveRecordStatus(arStatus);
        });
      } else if (this.objRecordDetails['module'] === 'jobs' && arStatus['id'] !== 'completed') {
        this.recordService.getRecord('jobs',this.objRecordDetails["id"]).subscribe( response => {
          let recordDetails = response['record_details'];
          if (
            recordDetails['status'] == 'completed'
            && recordDetails['amount_actually_invoiced'] != 0
            && recordDetails['amount_actually_invoiced'] >= recordDetails['amount_to_invoice']
          ) {
            this.notifService.sendConfirmation('confirm_reopen_job', 'confirmation', 'default')
              .pipe(
                filter(confirmation => confirmation.answer === true),
              )
              .subscribe( () => {
                this.saveRecordStatus(arStatus)
              });
          } else {
            this.saveRecordStatus(arStatus);
          }
        });
      } else {
        // Check if do we have converted status
        if (arStatus['id'] == 'converted' || arStatus['id'] == 'closed_won') {

          // Pass the status widget value, so we can preview the convert dialog.
          this.viewService.updateStatusWidget({
            type: 'converted',
            id: this.numInstanceId,
            data: { module: this.objRecordDetails['module'], id: this.objRecordDetails['id']},
            instance_id: this.numInstanceId
          });
        } else {
          this.saveRecordStatus(arStatus);
        }
      }
    }
  }

  /**
   * Update the record status
   *
   * @param status current selected status
   * @returns {void}
   */
  saveRecordStatus(status): void {

    if (data_is_true(data_get(status, 'is_allowed'))) {
      //Mark all task as complete
      if (data_get(status, 'id') == 'completed'
          && data_get(this.objRecordDetails, 'module') == 'jobs'
          && data_is_true(data_get(this.viewService.arRecord, 'has_tasks'))
      ) {
        this.notifService.sendConfirmation('mark_all_task_as_complete','warning').subscribe(result=>{
          this.recordService.saveRecord(this.objRecordDetails["module"], {
            [this.strField]: status["id"],
            is_completed: result.answer,
            mark_as_complete: result.answer,
            user_id: this.localStorageService.getItem('user_id'),
            record_id: this.objRecordDetails["id"]
          },
            this.objRecordDetails["id"])
            .subscribe(data => {
              this.strStatusSelected = status;
              // Pass the status widget value, so we can update the record.
              this.viewService.updateStatusWidget({
                type: "update",
                data: { module: this.objRecordDetails["module"], id: this.objRecordDetails["id"] },
                instance_id: this.numInstanceId
              });
              this._activities.sendRefresh(result.answer);
              this.notifService.notifySuccess('status_update_success');
            });
        })
      }
      else {
        let updatedStatus = {
          [this.strField]: status["id"]
        };

        // if new substatus isn't in the same current status
        if (filled(this.newSubStatus)) {
          updatedStatus['substatus'] = data_get(this.newSubStatus, 'key');
          this.strSubstatusSelected = this.newSubStatus;
          this.newSubStatus = [];
        } else {
          updatedStatus['substatus'] = null;
          this.strSubstatusSelected = [];
        }

        // Update the current record.
        this.recordService.saveRecord(this.objRecordDetails["module"], updatedStatus, this.objRecordDetails["id"])
          .subscribe(data => {
            this.strStatusSelected = status;
            // Pass the status widget value, so we can update the record.
            this.viewService.updateStatusWidget({
              type: "update",
              data: { module: this.objRecordDetails["module"], id: this.objRecordDetails["id"] },
              instance_id: this.numInstanceId
            });
            this.notifService.notifySuccess('status_update_success');
          });
      }
    } else {
      this.notifService.notifyError('not_allowed_status');
    }
  }

  getStatus = () => observe({
    observable: () => {
      return this.dropdownService.getJobStatusDropdown();
    }
  }).subscribe((response) => {
    let status = response['dropdowns'].filter(option => option.dropdown_field == 'status');
    let substatus = response['dropdowns'].filter(option => option.dropdown_field == 'substatus');
    let types = response['dropdowns'].filter(option => option.dropdown_field == 'type');

    status.forEach(status => {
      if (blank(status['id'])) {
        status['id'] = generate_id();
      }
    });

    substatus.forEach(substatus => {
      if (blank(substatus['id'])) {
        substatus['id'] = generate_id();
      }

        if (blank(substatus['parent_job_status_id'])) {
          let assignedStatus = when(substatus['key'] == 'site_not_accessible', {
            then: () => 'office_review',
            else: () => 'in_progress'
          });

          const defaultStatus = status.find(status => status['key'] == assignedStatus);
          const defaultStatusId = data_get(defaultStatus, 'id');

          substatus['parent_job_status_id'] = defaultStatusId;
        }

        if (blank(substatus['parent_job_type_id'])) {
          const simpleJob = types.find(type => type['key'] == 'simple_job');
          const simpleJobId = data_get(simpleJob, 'id');

          substatus['parent_job_type_id'] = simpleJobId;
        }
    })

    this.jobTypes = types;

    this.jobStatus = status.map(status => ({
      ...status,
      substatus: substatus.filter(sub => sub.parent_job_status_id === status.id)
    }));
  });

  isStatusChangeAllowed(allowedRoles, field) {
    const activeClient = this.clientStoreService.getActiveClient();
    let isAllowed = true;

    if (filled(allowedRoles)) {
      let activeClientRoles = activeClient.roles;

      if (field == 'status') {
        isAllowed = activeClientRoles.some(activeRole => allowedRoles.includes(activeRole['id']));
      } else if (field == 'substatus') {
        isAllowed = activeClientRoles.some(activeRole => allowedRoles.some(role => role['id'] == activeRole['id']));
      }
    }

    // FC-4946: If user has roles, Status / Substatus change is allowed
    // for that. Also allowed if user has no roles or is admin

    return activeClient.level == 'admin' || isAllowed || blank(allowedRoles);
  }

  mouseover(status) {
    if (this.objRecordDetails['module'] == 'jobs') {
      this.bShowSubstatus = true;
      let hoveredStatus = this.jobStatus.find(option => option.key == status.id);
      let substatus = fallback(data_get(hoveredStatus, 'substatus'), {
        fallback: () => []
      });

      let currentJobType = this.jobTypes.find(type => type['key'] == this.strJobTypeSelected['key']);
      let currentJobTypeId = data_get(currentJobType, 'id');

      substatus = substatus
        .sort(function(a, b) {
          return a.position - b.position;
        })
        .map(sub => {
          sub.is_allowed = this.isStatusChangeAllowed(data_get(sub, 'allowed_roles'), 'substatus');
          return sub;
        })
        .filter(sub => sub['parent_job_type_id'] == currentJobTypeId);

      this.jobSubStatus$.next(substatus);

      const selectedStatus = this.jobStatus.find(option => option.key == this.strStatusSelected.id);
      let assignedSubstatus = fallback(data_get(selectedStatus, 'substatus'), {
        fallback: () => []
      });

      let numSubIndex = assignedSubstatus.findIndex(x => x['key'] == this.strSubstatusSelected['key']);
      if (numSubIndex >= 0) {
        this.strSubstatusSelected = assignedSubstatus[numSubIndex];
      }
    }
  }

  updateSubstatus(substatus, status) {
    let isSubAllowed = data_get(substatus, 'is_allowed');

    if (data_is_true(isSubAllowed)) {
      if (this.strStatusSelected['status_id'] == substatus['parent_job_status_id']
          && substatus['key'] != this.strSubstatusSelected['key']) {
        // If new substatus is in the same current status
        this.recordService.saveRecord(this.objRecordDetails["module"], { 'substatus': data_get(substatus, 'key')}, this.objRecordDetails["id"])
          .subscribe(data => {
            this.strSubstatusSelected = substatus;
            this.viewService.updateStatusWidget({
              type: "update",
              data: { module: this.objRecordDetails["module"], id: this.objRecordDetails["id"] },
              instance_id: this.numInstanceId
            });
            this.notifService.notifySuccess('status_update_success');
          });
      } else {
        let isStatusAllowed = data_get(status, 'is_allowed');
        if (data_is_true(isStatusAllowed)) {
          this.newSubStatus = substatus;
        }
      }
    } else {
      this.notifService.notifyError('not_allowed_substatus');
    }
  }

  getTooltip(status) {
    if (!status['is_allowed']) {
      return this.translateService.instant('not_allowed_status_tooltip');
    }
  }

  getSubstatusStyle(status, substatus) {
    const isHoveredOrSelected =
    this.hoveredSubstatus === substatus.key ||
    substatus.id === this.strSubstatusSelected.id;

    if (!substatus.is_allowed || !status.is_allowed) {
      return { 'background-color': '#868e96', color: '#ffffff', cursor: 'not-allowed' };
    }

    if (isHoveredOrSelected) {
      let textColor = when(substatus.color == '#ffffff', {
        then: () => get_text_color_from_hex(substatus.color),
        else: () => '#ffffff'
      });

      return { 'background-color': substatus.color, color: textColor };
    }

    return { 'background-color': '#ffffff', color: '#0e76bc' };
  }
}
